// extracted by mini-css-extract-plugin
export var section = "teams-module--section--mi9Qn";
export var box = "teams-module--box--QQ3BQ";
export var title = "teams-module--title--rSF14";
export var subTitle = "teams-module--sub-title--wXb-K";
export var para = "teams-module--para--4HB7B";